<template>
	<footer class="container-fluid text-center footer" style="margin-bottom:20px;">
		<hr>
		<p>
			{{$t('misc.license')}} <a href="https://tiefox.de/">Tiefox.de</a>
		</p>
	</footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/design/Footer.vue